import { Component, Inject, Injectable } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { HttpResponseHandler } from "@app/shared/services/http-response-handler";
import { MatIconLoaderService } from "@app/shared/services/mat-icon-loader.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TypedAction } from "@ngrx/store/src/models";
import { map } from "rxjs/operators";
import { RouterActions } from "..";
import { RouteInfo } from "../actions";
import * as SnackbarActions from "../actions/snackbar.action";

@Component({
    template: `
        <div class="mat-simple-snackbar">
            <mat-icon *ngIf="data?.icon" [svgIcon]="data.icon" class="snackbar-icon"></mat-icon>
            <span class="text">{{ data.message }}</span>
            <div class="mat-simple-snackbar-action">
                <button *ngIf="data.buttonText" mat-button class="mat-button" (click)="snackBarRef.dismiss()">
                    {{ data.buttonText }}
                </button>
            </div>
        </div>
    `,
    styles: [
        `
            :host-context(.danger) {
                .text,
                .mat-button {
                    color: #fff;
                }
            }

            :host-context(.success) {
                .mat-button {
                    border: 2px solid #2c7f9b !important;
                    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                }
            }

            .snackbar-icon {
                margin-right: 8px;
            }

            .mat-simple-snackbar {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-shrink: 0;
                border-radius: 0;
                color: #1a1a1a;
                text-align: left;
                font-size: 14px;
            }

            .mat-simple-snackbar-action {
                flex-shrink: 0;
                margin: -8px -8px -8px 8px;
                color: #fff;

                button {
                    color: black;
                    margin-left: 20px;
                    display: flex;
                    width: 90px;
                    height: 30px;
                    padding: 8.182px 0px;
                    justify-content: center;
                    align-items: center;
                    flex-shrink: 0;
                    border-radius: 8px;
                }
            }
        `,
    ],
})
export class CustomSnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>) {}
}

@Injectable()
export class SnackbarEffects {
    private snackbarOpen({ message = new HttpResponseHandler(), buttonText = "Ok", duration = 2000, path = "", stayAlive = false } = {}):
        | (RouteInfo & TypedAction<string>)
        | TypedAction<string> {
        const errorMessage =
            message.message?.trim().length > 150 ? `${message.message.trim().substring(0, 150)}...` : message.message.trim();
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: { message: errorMessage, buttonText, icon: !message.isError ? "cc-select" : null },
            duration: !message.isError && !stayAlive ? duration : null,
            verticalPosition: "top",
            panelClass: message.isError ? ["danger"] : ["success"],
        });

        if (path) {
            return RouterActions.routerGo({ path: [path] });
        }
        // need to be able to return an action
        return SnackbarActions.emptyAction();
    }

    openSnackbar$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SnackbarActions.openSnackbar),
            map(payload => this.snackbarOpen(payload))
        )
    );

    constructor(private actions$: Actions, private snackBar: MatSnackBar, matIconLoader: MatIconLoaderService) {
        matIconLoader.importIcons([[`cc-select`, `select`]]);
    }
}
